import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TBusyoRegisterPostReq, TBusyoUpdatePutReq } from "./TBusyo"

export const busyoRegisterPostReqSchema: JSONSchemaType<TBusyoRegisterPostReq> =
  {
    type: "object",
    properties: {
      営業所コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.営業所コード,
        pattern: validateConstant.PATTERN.数字のみ,
        minLength: 1,
        title: "営業所コード",
        errorMessage: util.stringErrorMessage("営業所コード", {
          required: true,
          maxLength: validateConstant.LENGTH.営業所コード,
        }),
      },
      部所コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.部所コード,
        pattern: validateConstant.PATTERN.数字のみ,
        minLength: 1,
        title: "部所コード",
        errorMessage: util.stringErrorMessage("部所コード", {
          required: true,
          maxLength: validateConstant.LENGTH.部所コード,
        }),
      },
      部所名: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        title: "部所名",
        minLength: 1,
        errorMessage: util.stringErrorMessage("部所名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      部所略称: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般略称,
        minLength: 1,
        title: "部所略称",
        errorMessage: util.stringErrorMessage("部所略称", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      運行部所フラグ: {
        enum: [0, 1],
        type: "number",

        pattern: validateConstant.PATTERN.数字のみ,
        title: "運行部所フラグ",
        errorMessage: util.stringErrorMessage("部所略称"),
      },
      市区町村コード: {
        type: "string",
        nullable: true,
        minLength: validateConstant.LENGTH.団体コード,
        maxLength: validateConstant.LENGTH.団体コード,
        pattern: validateConstant.PATTERN.数字のみ,
        title: "市区町村コード",
        errorMessage: util.stringErrorMessage("市区町村コード", {
          minLength: validateConstant.LENGTH.団体コード,
          maxLength: validateConstant.LENGTH.団体コード,
        }),
      },
      部所権限コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.部所権限コード,
        title: "部所権限コード",
        errorMessage: util.stringErrorMessage("部所権限コード", {
          required: true,
          maxLength: validateConstant.LENGTH.部所権限コード,
        }),
      },
    },
    required: [
      "営業所コード",
      "運行部所フラグ",
      "部所コード",
      "部所名",
      "部所略称",
      "部所権限コード",
    ],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "営業所コード",
        "運行部所フラグ",
        "部所コード",
        "部所名",
        "部所略称",
        "部所権限コード",
      ]),
    },
  }

export const busyoUpdatePutReqSchema: JSONSchemaType<TBusyoUpdatePutReq> = {
  type: "object",
  properties: {
    営業所コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.営業所コード,
      pattern: validateConstant.PATTERN.数字のみ,
      title: "営業所コード",
      errorMessage: util.stringErrorMessage("営業所コード", {
        required: true,
        maxLength: validateConstant.LENGTH.営業所コード,
      }),
    },
    部所コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.部所コード,
      pattern: validateConstant.PATTERN.数字のみ,
      title: "部所コード",
      minLength: 1,
      errorMessage: util.stringErrorMessage("部所コード", {
        required: true,
        maxLength: validateConstant.LENGTH.部所コード,
      }),
    },
    部所名: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般名称,
      title: "部所名",
      minLength: 1,
      errorMessage: util.stringErrorMessage("部所名", {
        required: true,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    部所略称: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般略称,
      title: "部所略称",
      minLength: 1,
      errorMessage: util.stringErrorMessage("部所略称", {
        required: true,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    運行部所フラグ: {
      enum: [0, 1],
      type: "number",
      pattern: validateConstant.PATTERN.数字のみ,
      title: "運行部所フラグ",
      errorMessage: util.stringErrorMessage("部所略称"),
    },
    市区町村コード: {
      type: "string",
      nullable: true,
      minLength: validateConstant.LENGTH.団体コード,
      maxLength: validateConstant.LENGTH.団体コード,
      pattern: validateConstant.PATTERN.数字のみ,
      title: "市区町村コード",
      errorMessage: util.stringErrorMessage("市区町村コード", {
        minLength: validateConstant.LENGTH.団体コード,
        maxLength: validateConstant.LENGTH.団体コード,
      }),
    },
    部所権限コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.部所権限コード,
      title: "部所権限コード",
      errorMessage: util.stringErrorMessage("部所権限コード", {
        required: true,
        maxLength: validateConstant.LENGTH.部所権限コード,
      }),
    },
    更新日時: {
      type: "string",
      title: "更新日時",
    },
  },
  required: [
    "営業所コード",
    "更新日時",
    "運行部所フラグ",
    "部所コード",
    "部所名",
    "部所略称",
    "部所権限コード",
  ],
  errorMessage: {
    required: util.JsonSchemeRequiredErrorMessages([
      "営業所コード",
      "更新日時",
      "運行部所フラグ",
      "部所コード",
      "部所名",
      "部所略称",
      "部所権限コード",
    ]),
  },
}
